<template>
  <div class="Main-Inner">
    <div class="Main-Content">
      <LoadingLayout />
    </div>
  </div>
</template>

<script>

export default {
  name: 'Insights',
  mounted() {
    window.location = '/insights/'
  }
}
</script>
